import { render } from "./CreateFromSetLight.vue?vue&type=template&id=4ea36e10"
import script from "./CreateFromSetLight.vue?vue&type=script&lang=js"
export * from "./CreateFromSetLight.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janvalenta/Documents/Projects/sites/somisale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__